import { omit } from 'lodash';

import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchSubjectList({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/subjects`, { params })
    .then(res => (res.data))
    .then(subjectList => (
      dispatch('setSubjects', subjectList)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching subjects:', err);
      return Promise.reject(err);
    });
}

export function fetchGradeList({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/grades`, { params })
    .then(res => (res.data))
    .then(gradeList => (
      dispatch('setGrades', gradeList)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching grades:', err);
      return Promise.reject(err);
    });
}

export function fetchUnits({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/units`, { params })
    .then(res => (res.data))
    .then(units => (
      dispatch('setUnits', units)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching units:', err);
      return Promise.reject(err);
    });
}

export function fetchCoreConcepts({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/core-concepts`, { params })
    .then(res => (res.data))
    .then(coreConcepts => (
      dispatch('setCoreConcepts', coreConcepts)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching core concepts:', err);
      return Promise.reject(err);
    });
}

export function fetchDomainList({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/domains`, { params })
    .then(res => (res.data))
    .then(domains => (
      dispatch('setDomains', domains)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching domains:', err);
      return Promise.reject(err);
    });
}

export function fetchDomain(_, domainId) {
  return http.get(`${MINERVA_API_URL}/domains/${domainId}`)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching domain:', err);
      return Promise.reject(err);
    });
}

export function fetchDomainConceptList(_, params) {
  return http.get(`${MINERVA_API_URL}/domain-concepts`, { params })
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching domain concepts:', err);
      return Promise.reject(err);
    });
}

export function fetchDomainConcept(_, conceptId) {
  return http.get(`${MINERVA_API_URL}/domain-concepts/${conceptId}`)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching domain concept:', err);
      return Promise.reject(err);
    });
}

export function fetchLearningElementList(_, params) {
  return http.get(`${MINERVA_API_URL}/learning-elements`, { params })
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching learning elements:', err);
      return Promise.reject(err);
    });
}

export function fetchGradeSubjects({ commit }, params) {
  if (params.grade === '0' || params.grade === 'null') {
    // eslint-disable-next-line no-param-reassign
    params = {
      ...omit(params, 'grade'),
    };
  }

  return http.get(`${MINERVA_API_URL}/subjects`, { params })
    .then(res => (commit(types.FETCH_GRADE_SUBJECTS, res.data)))
    .catch(err => Promise.reject(err));
}

export function resetGradeSubjects({ commit }) {
  commit(types.RESET_GRADE_SUBJECTS);
}

export function setMyCardsFilter({ commit }, filterInfo) {
  commit(types.SET_MY_CARDS_FILTER, filterInfo);

  return Promise.resolve();
}

export function setLibrartFilter({ commit }, filterInfo) {
  commit(types.SET_LIBRARY_FILTER, filterInfo);

  return Promise.resolve();
}

export function setPageLibraryFilter({ commit }, filterInfo) {
  commit(types.SET_PAGE_LIBRARY_FILTER, filterInfo);

  return Promise.resolve();
}

export function setAssignmentsFilter({ commit }, filterInfo) {
  commit(types.SET_ASSIGNMENTS_FILTER, filterInfo);

  return Promise.resolve();
}

export function setCoreConcepts({ commit }, coreConcepts) {
  commit(types.SET_CORE_CONCEPTS, coreConcepts);

  return Promise.resolve(coreConcepts);
}

export function setDomains({ commit }, domains) {
  commit(types.SET_DOMAINS, domains);

  return Promise.resolve(domains);
}

export function setUnits({ commit }, units) {
  commit(types.SET_UNITS, units);

  return Promise.resolve(units);
}

export function setSubjects({ commit }, subjectList) {
  commit(types.SET_SUBJECTS, subjectList);

  return Promise.resolve(subjectList);
}

export function setGrades({ commit }, gradeList) {
  commit(types.SET_GRADES, gradeList);

  return Promise.resolve(gradeList);
}



// WEBPACK FOOTER //
// ./src/app/browse-filters/store/actions.js